import { MAX_COLUMNS } from "../constants";

export function filterBetsByNumberOfOdds(bets, customCols, includeColumnBets = false) {	
	const maxColumns = customCols ? customCols: MAX_COLUMNS;
    let filteredBets = [], columnBets = [];
	let columns = 0;
	bets.forEach(bet => {
		if (bet.forceOddsListColumn || bet.compactView) {
			columnBets.push(bet);
            return;
        }

        let nOdds = bet.odds.length;
        if (bet.parametrica) {
            nOdds++;
        }
        if (columns + nOdds <= maxColumns) {
            columns += nOdds;
            filteredBets.push(bet);
        } else if (nOdds > maxColumns) {
            columnBets.push(bet);
        }
    });

    if (includeColumnBets) {
        return [filteredBets, columnBets]
    } else {
        return filteredBets;
    }
}
